import script from "./FavoriteChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteChip.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteChip.vue?vue&type=style&index=0&id=5db281ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db281ca"]])

export default __exports__